import { FormField } from '../types/ContactForm';


export const generateUniqueFieldName = (
    label: string,
    allFields: FormField[],
    excludeFieldIndex?: number
): string => {
    let baseName = label
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9_]/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_|_$/g, '');

    if (!baseName) {
        baseName = 'field';
    }

    const existingNames = allFields
        .filter((_, index) => excludeFieldIndex === undefined || index !== excludeFieldIndex)
        .map(f => f.name);

    let uniqueName = baseName;
    let counter = 1;

    while (existingNames.includes(uniqueName)) {
        uniqueName = `${baseName}_${counter}`;
        counter++;
    }

    return uniqueName;
};

